import React from 'react';
import {
  Card,
  Layout,
  SkeletonBodyText,
  SkeletonDisplayText,
  SkeletonPage
} from '@shopify/polaris';

const PageLoading = () => {
  return (
    <SkeletonPage primaryAction secondaryActions={2}>
      <Layout>
        <Layout.Section>
          <Card>
            <Card>
              <SkeletonBodyText />
            </Card>
          </Card>
          <Card>
            <Card>
              <SkeletonDisplayText size="small" />
              <SkeletonBodyText />
            </Card>
          </Card>
          <Card>
            <Card>
              <SkeletonDisplayText size="small" />
              <SkeletonBodyText />
            </Card>
          </Card>
        </Layout.Section>
        <Layout.Section secondary>
          <Card>
            <Card>
              <SkeletonDisplayText size="small" />
              <SkeletonBodyText lines={2} />
            </Card>
            <Card>
              <SkeletonBodyText lines={1} />
            </Card>
          </Card>
          <Card>
            <Card>
              <SkeletonDisplayText size="small" />
              <SkeletonBodyText lines={2} />
            </Card>
            <Card>
              <SkeletonBodyText lines={2} />
            </Card>
          </Card>
        </Layout.Section>
      </Layout>
    </SkeletonPage>
  );
};

export default PageLoading;
